<template>
  <div
    :class="collapsed ? 'max-w-0' : 'max-w-full'"
    class="relative h-full transition-all transition-500">
    <svg id="collapse-container" class="absolute z-20" height="60" width="60">
      <g
        id="collapse-button"
        :class="[{
          'collapse-button-collapsed': btnCollapsed,
          'collapse-button-hover cursor-pointer': btnHover
        }]"
        @click=toggleCollapse()
        @mouseover=toggleCollapseHover()
        @mouseout=toggleCollapseHover()>
        <path class="transition-all transition-500"
              d="M0,0
                Q 40,30 0,60"
              id="outside-thing"/>
        <path class="transition-all transition-500"
              d="M6,25
                L10,30
                L6,35"
              id="little-arrow"/>
      </g>
    </svg>
    <div
      :class="{'border-r border-gray-600': btnHover}"
      class="h-full overflow-y-auto w-300px p-2 transition-all transition-500">
      <div class="w-full flex flex-col justify-center p-3 mb-2 rounded border border-gray-300">
        <h4 class="text-base text-center border-b border-pink-200 pb-2 mb-2">
          Data
        </h4>
        <div class="mb-2">
          <span class="text-sm text-gray-700">Value to project</span>
          <v-select
            :options="variables.options"
            v-model="variables.selected"
            @input="changeVariable"
            :key="variables.selected"
            :reduce="option => option.id"
            :clearable=false
            class="w-full text-sm">
          </v-select>
        </div>
        <div class="mb-2">
          <span class="text-sm text-gray-700">Scale</span>
          <v-select
            :options="levelOptions"
            v-model="levels.selected"
            @input="changeLevel"
            :key="levels.selected"
            :reduce="option => option.value"
            :clearable=false
            class="w-full text-sm">
          </v-select>
        </div>
      </div>
      <div class="w-full flex flex-col justify-center p-3 mb-2 rounded border border-gray-300">
        <h4 class="text-base text-center border-b border-pink-200 pb-2 mb-2">
          Map
        </h4>
        <div class="mb-2">
          <span class="text-sm text-gray-700">Color scheme</span>
          <v-select
            :options="scaleColor.options"
            v-model="scaleColor.selected"
            :reduce="option => option.value"
            label="text"
            @input="changeColor"
            :clearable=false
            class="w-full text-sm">
          </v-select>
        </div>
        <div class="mb-2">
          <span class="text-sm text-gray-700">Number of classes (categories)</span>
          <v-select
            :options="nColorCategories.options"
            v-model="nColorCategories.selected"
            @input="changeNColorCategories"
            :clearable=false
            class="w-full text-sm">
          </v-select>
        </div>
        <div class="mb-2">
          <span class="text-sm text-gray-700">Discretization method</span>
          <v-select
            :options="scales.options"
            v-model="scales.selected"
            @input="changeScaleType"
            :key="scales.selected"
            :reduce="option => option.value"
            :clearable=false
            class="w-full text-sm">
          </v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { EventBus } from '../event-bus';

export default {
  name: 'LeftPanel',
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      collapsed: false,
      btnCollapsed: false,
      btnHover: false,
      scaleColor: {
        selected: 'purple-red',
        options: [
          { text: 'Blue', value: 'blue' },
          { text: 'Green', value: 'green' },
          { text: 'Grey', value: 'grey' },
          { text: 'Orange', value: 'orange' },
          { text: 'Purple', value: 'purple' },
          { text: 'Red', value: 'red' },
          { text: 'Blue - green', value: 'blue-green' },
          { text: 'Blue - purple', value: 'blue-purple' },
          { text: 'Green - blue', value: 'green-blue' },
          { text: 'Orange - red', value: 'orange-red' },
          { text: 'Purple - blue - green', value: 'purple-blue-green' },
          { text: 'Purple - blue', value: 'purple-blue' },
          { text: 'Purple - red', value: 'purple-red' },
          { text: 'Red - purple', value: 'red-purple' },
          { text: 'Yellow - green - blue', value: 'yellow-green-blue' },
          { text: 'Yellow - green', value: 'yellow-green' },
          { text: 'Yellow - orange - brown', value: 'yellow-orange-brown' },
          { text: 'Yellow - orange - red', value: 'yellow-orange-red' },
        ],
      },
      variables: {
        selected: null,
        options: [],
      },
      nColorCategories: {
        selected: 4,
        options: [3, 4, 5, 6, 7, 8, 9, 10],
      },
      levels: {
        selected: null,
        options: [
          { label: 'Countries', value: 'countries' },
          { label: 'Regions', value: 'regions' },
          { label: 'Urban areas', value: 'urban_areas' },
          { label: 'Urban and rural areas', value: 'rural_urban_areas' },
          { label: 'WorldSciAgglo', value: 'WorldSciAgglo' },
          { label: 'NUTS3 2021', value: 'NUTS3_2021' },
          { label: 'RISIS adapted NUTS 2021', value: 'RISIS_adapted_NUTS_2021' },
        ],
        enabled: [],
      },
      scales: {
        selected: 'natural_breaks',
        options: [
          { label: 'Natural breaks', value: 'natural_breaks' },
          { label: 'Quantiles', value: 'quantile' },
        ],
      },
    };
  },
  computed: {
    levelOptions() {
      const result = this.levels.options.filter(
        opt => this.levels.enabled.find(elem => elem === opt.value),
      );
      return result;
    },
  },
  methods: {
    changeColor() {
      EventBus.$emit('changeColor', this.scaleColor.selected);
    },
    changeVariable() {
      const option = this.variables.options.find(opt => opt.id === this.variables.selected);
      console.log('change variable emitted', option);
      EventBus.$emit('changeVariable', option);
    },
    changeNColorCategories() {
      EventBus.$emit('changeNColorCategories', this.nColorCategories.selected);
    },
    changeScaleType() {
      EventBus.$emit('changeScaleType', this.scales.selected);
    },
    changeLevel() {
      this.$router.push(
        {
          name: 'map',
          params: {
            projectid: this.$route.params.projectid,
            level: this.levels.selected,
          },
        },
      );
    },
    loadData(data) {
      this.variables.options = data.attributes;
      this.variables.selected = data.initial_viz_value;
      this.levels.enabled = data.enabled_scales;
      this.levels.selected = data.scale;
    },
    setupEvents() {
      const that = this;
      EventBus.$on('loaded', that.loadData);
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      this.btnCollapsed = this.collapsed;
    },
    toggleCollapseHover() {
      this.btnHover = !this.btnHover;
    },
  },
  mounted() {
    this.setupEvents();
  },
};
</script>

<style lang="stylus">
  .w-300px
    width 300px

  .max-w-0
    max-width 0

  .max-w-full
    max-width 300px

  #collapse-container
    top calc(50% - 30px)
    right -59px

  #collapse-button
    fill white

  .collapse-button-hover
    #outside-thing
      stroke gray
      stroke-width 1px

  #little-arrow
    stroke-width 2px
    stroke black
    fill none
    transform-origin 13% 50%

  .collapse-button-collapsed
    #little-arrow
      transform rotate(-180deg)
</style>
